import React, { useLayoutEffect } from 'react';
import { Portal } from './Portal';

export const FullScreenOverlay = ({ children, isOpen }) => {
    useLayoutEffect(() => {
        const $body = document.querySelector('body');

        $body.style.removeProperty('overflow');
        if (isOpen) {
            $body.style.setProperty('overflow', 'hidden');
        }
        
        return () => {
            $body.style.removeProperty('overflow');
        };
    }, [isOpen]);
    
    if (!isOpen) {
        return null;
    }
    
    return (
        <Portal>
            <div className="modal fade show" tabIndex="-1" role="dialog">
                {children}
            </div>
        </Portal>
    );
};
